import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton, SkeletonTable } from "../../components/Skeleton";
import {
  manageProjectActionRequest,
  projectDeleteRequest,
} from "../../redux/action/manageProjectAction";
import Utils from "../../utility/utility";
import { STRING } from "../../constants/string";
import Select from "react-select";
import { NavLink, Link } from "react-router-dom";
import { postApiCall } from "../../service/PostApiCall";
import { DELETE_PROJECT, PROJECT_HELPER } from "../../service/apiUrl";
import ReactPaginate from "react-paginate";
import CustomModal from "../../components/CustomModal";
import ConfirmDialog from "../../components/ConfirmDialog";

const ManageProject = (props) => {
  const [searchName, setSearchName] = useState("");
  const [helperData, setHelperData] = useState([]);
  const [technology, setTechnology] = useState({ value: "", label: "" });
  const [developer, setDeveloper] = useState({ value: "", label: "" });
  const [source, setSource] = useState({ value: "", label: "" });
  const [projectSize, setProjectSize] = useState({ value: "", label: "" });
  const [manager, setManager] = useState({ value: "", label: "" });
  const [trackerId, setTrackerId] = useState({ value: "", label: "" });
  const [billingType, setBillingType] = useState({ value: "", label: "" });
  const [update, setUpdate] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [showDevelpers, setShowDevelpers] = useState({
    status: false,
    data: [],
  });
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  const projectList = useSelector((state) => state.manageProjectReducer);
  const signdata = useSelector((state) => state.signinReducers);
  const access_token = signdata?.data?.access_token;
  

  const dispatch = useDispatch();
  useEffect(() => {
    const params = {
      name: searchName,
      type: billingType?.value,
      technology: technology?.value,
      developer: developer?.value,
      manager: manager?.value,
      projectSize: projectSize?.value,
      source: source?.value,
      trackerId: trackerId?.value,
      pageSize: pageSize,
      page: currentPage,
    };

    if (access_token) {
      dispatch(manageProjectActionRequest(params, access_token));
    } else {
      console.error("projectList error");
    }
  }, [access_token, dispatch, update]);

  useEffect(() => {
    postApiCall([], signdata?.data?.access_token, PROJECT_HELPER)
      .then((result) => {
        setHelperData(result);
      })
      .catch((error) => {
        console.error("PROJECT_HELPER", error);
      });
  }, []);

  const confirmDeleteProject = () => {
    if (!pendingDeleteId) {
      return false;
    }
    const params = {
      id: pendingDeleteId,
    };
    // dispatch(projectDeleteRequest(params, access_token))
    return postApiCall(params, signdata?.data?.access_token, DELETE_PROJECT)
      .then((result) => {
        dispatch(manageProjectActionRequest(params, access_token));
        setPendingDeleteId(null);
      })
      .catch((error) => {
        console.error("PROJECT_deleted", error);
        throw error;
      });
  };

  const handlePageChange = (pageNumber) => {
    const page = pageNumber?.selected + 1;
    setCurrentPage(page);
    setUpdate(!update);
  };

  const closeDevelopers = () => {
    setShowDevelpers({ data: [], status: false });
  };

  return (
    <>
      <div className={props?.data?.transtion === true ? "contents" : "content"}>
        <div className="content-top-spacer"></div>
        <div className="color-body">
          <div className="page-head">
            <div className="page-eyebrow">Work</div>
            <h1 className="page-title">Manage Projects</h1>
          </div>
          <div className="col-md-12">
            <div className="card-input mt-3">
              <div className="col-md-12 mb-3">
                <div className="mt-5">
                  <div className="row">
                    <div className="col-md-4">
                      {/* <Link to="/add-project" className="create-button">
                        Create Project
                      </Link> */}
                    </div>
                    <div className="flex-row">
                      <div className="row mr-4 mt-1 mt-2">
                        <div className="dot dot-wraning mt-1 mr-1"></div>
                        <p>Waiting for completion</p>
                      </div>
                      <div className="row mr-4 mt-1 mt-2">
                        <div className="dot dot-hold mt-1 mr-1"></div>
                        <p>Hold</p>
                      </div>
                      <div className="row mr-4 mt-1 mt-2">
                        <div className="dot dot-active mt-1 mr-1"></div>
                        <p>Open</p>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="mt-2">
                      <p>
                        Successfully found{" "}
                        <b>
                          {projectList?.isLoading ? (
                            <Skeleton
                              className="sk-inline"
                              width="1.6ch"
                              height=".8em"
                            />
                          ) : (
                            <span className="reveal-in">{projectList?.data?.projects?.length}</span>
                          )}
                        </b>{" "}
                        Records
                      </p>
                    </div>
                    <div className="">
              <div className="listing-filters">
                <div className="filter-cell">
                  <label className="filter-label">Project Name</label>

                              <input
                                type="text"
                                className="w-75 pl-2 listing-serach min-h-38 mt-2 mb-2"
                                value={searchName}
                                onChange={(event) => {
                                  setSearchName(event.target.value);
                                  setUpdate(!update);
                                }}
                              />
                              {searchName.length > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    color: "var(--app-muted)",
                                    top: "50%",
                                    right: 90,
                                    transform: "translate(0%, -50%)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setSearchName("");
                                    setUpdate(!update);
                                  }}
                                >
                                  &#x2715;
                                </span>
                              )}
                </div>
                <div className="filter-cell">
                  <label className="filter-label">Technology</label>

                              <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                                options={helperData?.technologies}
                                className="w-100 listing-serach mt-2 mb-2"
                                placeholder="Select"
                                isSearchable={true}
                                isClearable={true}
                                value={technology}
                                styles={{
                                  menu: (base) => ({
                                    ...base,
                                    width: "max-content",
                                    minWidth: "100%",
                                  }),
                                }}
                                onChange={(event) => {
                                  setTechnology({
                                    value: event?.value,
                                    label: event?.label,
                                  });
                                  setUpdate(!update);
                                }}
                              />
                </div>
                <div className="filter-cell">
                  <label className="filter-label">Developers</label>

                              <Select classNamePrefix="rs" menuPortalTarget={document.body} menuPosition="fixed"
                                options={helperData?.developers}
                                className="w-100 listing-serach mt-2 mb-2"
                                placeholder="Select"
                                isSearchable={true}
                                isClearable={true}
                                value={developer}
                                styles={{
                                  menu: (base) => ({
                                    ...base,
                                    width: "max-content",
                                    minWidth: "100%",
                                  }),
                                }}
                                onChange={(event) => {
                                  setDeveloper({
                                    value: event?.value,
                                    label: event?.label,
                                  });
                                  setUpdate(!update);
                                }}
                              />
                </div>
              </div>

                      <SkeletonTable
                        loading={projectList?.isLoading}
                        className="table table-sm"
                        rows={8}
                        columns={5}
                        head={
                          <>
                        <colgroup>
                          <col width="3%" />
                          <col width="30%" />
                          <col width="20%" />
                          <col width="15%" />
                          <col width="22%" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th scope="col" className="site-color">
                              <span className="mt-2 mb-2 d-flex"> #</span>
                            </th>
                            <th
                              scope="col"
                              className="site-color"
                              style={{ width: "12%" }}
                            >
                              <span className="mt-2 mb-2 d-flex">
                                Project Name
                              </span>
                            </th>
                            <th scope="col" className="site-color">
                              <span className="mt-2 mb-2 d-flex">
                                Technology
                              </span>
                            </th>
                            <th scope="col" className="site-color">
                              <span className="mt-2 mb-2 d-flex">
                                Developers
                              </span>
                            </th>
                            <th scope="col" className="site-color">
                              <span className="mt-2 mb-2 d-flex"> Manage</span>
                            </th>
                          </tr>
                        </thead>
                          </>
                        }
                      >
                          {projectList?.data?.projects?.length ? (
                            <>
                              {projectList?.data?.projects?.map(
                                (project, idx) => {
                                  return (
                                    <tr key={idx}>
                                      <td>
                                        <span className="mt-4 d-flex mr-4">
                                          {(currentPage - 1) * pageSize +
                                            (idx + 1)}
                                        </span>
                                      </td>
                                      <td>
                                        <div className="mt-2 mb-2">
                                          <div className="row">
                                            <div className="ml-3">
                                              <Link className="text-reset text-decoration-none" to={`/view-project/${project.id}`}>
                                              {project?.name ?? "NA"}
                                              </Link>
                                            </div>
                                            {/* <div className="dot-set"></div>
                                            <div className="dot-light"></div> */}
                                          </div>
                                          <div className="small mb-1">
                                              (
                                              {Utils.momentDateFromTimestamp(
                                                STRING.PROJECT_DATE_FORMAT,
                                                project?.created_at
                                              )}
                                              )
                                          </div>
                                          <div className="">
                                            <div className="progress">
                                              <div
                                                className="progress-bar bg-info"
                                                role="progressbar"
                                                style={{ width: "50%" }}
                                                aria-valuenow="50"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              ></div>
                                            </div>
                                          </div>
                                        </div>
                                      </td>

                                      <td className="align-middle">
                                        <ul className="m-0">
                                          {project?.technology?.map((dev) => {
                                            return (
                                              <li key={dev?.id}>{dev?.name}</li>
                                            );
                                          })}
                                        </ul>
                                      </td>

                                      <td className="align-middle">
                                        <ul className="m-0">
                                          {project?.assigned_developer?.map(
                                            (dev) => {
                                              return (
                                                <li key={dev.id}>{dev.name}</li>
                                              );
                                            }
                                          )}
                                        </ul>
                                      </td>

                                      <td className="align-middle">
                                        <div className="d-flex m-0">
                                          <div className="mr-3 btn btn-light">
                                            <Link
                                              to={`/view-project/${project.id}`}
                                            >
                                              <i
                                                className="fa fa-eye site-color curser-point"
                                                aria-hidden="true"
                                              ></i>
                                            </Link>
                                          </div>
                                          <div className="btn btn-light">
                                            <Link
                                              to={`/update-project/${project.id}`}
                                            >
                                              <i
                                                className="fa fa-pencil site-color curser-point"
                                                aria-hidden="true"
                                              ></i>
                                            </Link>
                                          </div>
                                          <div className="ml-3 btn btn-light">
                                            <button
                                              type="button"
                                              className="lb-bare site-color curser-point"
                                              aria-label="Delete project"
                                              title="Delete project"
                                              onClick={() =>
                                                setPendingDeleteId(project.id)
                                              }
                                            >
                                              <i
                                                className="fa fa-trash"
                                                aria-hidden="true"
                                              ></i>
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </>
                          ) : (
                            <tr>
                              <td colSpan="10">No record found</td>
                            </tr>
                          )}
                      </SkeletonTable>

                      {projectList?.data?.projects?.length > 0 && (
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={projectList?.data?.total_pages}
                          onPageChange={handlePageChange}
                          containerClassName={"pagination"}
                          activeClassName={"active"}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isShow={showDevelpers.status}
        onHide={closeDevelopers}
        heading="Developers list"
        footer={
          <button
            type="button"
            className="app-dialog-btn app-dialog-btn-ghost"
            onClick={closeDevelopers}
          >
            Close
          </button>
        }
      >
        <div className="row">
          <div className="col-md-12">
            <ul className="row">
              {showDevelpers?.data?.map((value, i) => {
                return (
                  <li className="col-md-4" key={i}>
                    {value?.name}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </CustomModal>
      <ConfirmDialog
        isShow={Boolean(pendingDeleteId)}
        onHide={() => setPendingDeleteId(null)}
        title="Delete this project?"
        description="The project and its tracker links are removed from the listing. This cannot be undone."
        confirmLabel="Delete"
        successLabel="Deleted"
        cancelLabel="Cancel"
        tone="danger"
        onConfirm={confirmDeleteProject}
      />
    </>
  );
};

export default ManageProject;
